import { render, staticRenderFns } from "./dashboard.page.vue?vue&type=template&id=5d6a59cf&scoped=true&"
import script from "./dashboard.page.vue?vue&type=script&lang=js&"
export * from "./dashboard.page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.page.vue?vue&type=style&index=0&id=5d6a59cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a59cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
